import {
  hasAuthToken,
  isAuthExcludedPath,
  shouldSkipIframeRouteRestore
} from '@libs/authSession';

const ROUTE_SYNC_MESSAGE_TYPE = {
  REPORT: 'ROUTE_CHANGE',
  RESTORE: 'RESTORE'
};

function isInIframe() {
  return window.self !== window.top;
}

function canRestoreRoute(fullPath) {
  if (!fullPath || shouldSkipIframeRouteRestore()) {
    return false;
  }
  const path = fullPath.split('?')[0];
  if (isAuthExcludedPath(path)) {
    return false;
  }
  return hasAuthToken();
}

function getFullPath(payload) {
  if (!payload || typeof payload !== 'object') {
    return '';
  }
  return typeof payload.fullPath === 'string' ? payload.fullPath : '';
}

function reportRouteChange(route) {
  if (!isInIframe() || !window.parent) {
    return;
  }
  window.parent.postMessage(
    {
      type: ROUTE_SYNC_MESSAGE_TYPE.REPORT,
      payload: {
        fullPath: route.fullPath
      }
    },
    '*'
  );
}

/**
 * Sync child-router state with parent app via postMessage.
 * Parent protocol:
 * - Child report: { type: 'ROUTE_CHANGE', payload: { fullPath } }
 * - Parent restore: { type: 'RESTORE', payload: { fullPath } }
 */
export function setupIframeRouteSync(router) {
  if (!router) {
    return;
  }

  let isRestoringFromParent = false;

  window.addEventListener('message', async event => {
    const { data } = event || {};
    if (!data || data.type !== ROUTE_SYNC_MESSAGE_TYPE.RESTORE) {
      return;
    }

    const restoredFullPath = getFullPath(data.payload);
    if (
      !restoredFullPath ||
      restoredFullPath === router.currentRoute.value.fullPath ||
      !canRestoreRoute(restoredFullPath)
    ) {
      return;
    }

    isRestoringFromParent = true;
    try {
      await router.replace(restoredFullPath);
    } catch {
      // Ignore invalid/expired paths from parent persisted cache.
    } finally {
      isRestoringFromParent = false;
    }
  });

  router.afterEach(to => {
    if (isRestoringFromParent || isAuthExcludedPath(to.path)) {
      return;
    }
    if (!hasAuthToken()) {
      return;
    }
    reportRouteChange(to);
  });
}
